// src/context/modules/teamMembersModule.js
import { useState, useCallback } from "react";
import {
  fetchTeamMembers,
  updateTeamMember,
  createTeamMember,
  deleteTeamMember,
} from "../../api/teamMemberApi";

export const useTeamMembersModule = () => {
  // State
  const [teamMembers, setTeamMembers] = useState([]);
  const [teamMembersLoading, setTeamMembersLoading] = useState(true);

  // Operations
  const refreshTeamMembers = useCallback(async () => {
    setTeamMembersLoading(true);
    try {
      const newTeamMembers = await fetchTeamMembers();
      setTeamMembers(newTeamMembers);
      return newTeamMembers;
    } catch (error) {
      console.error("Error refreshing team members:", error);
      throw error;
    } finally {
      setTeamMembersLoading(false);
    }
  }, []);

  const addTeamMember = useCallback(
    async (memberData) => {
      setTeamMembersLoading(true);
      try {
        const newMember = await createTeamMember(memberData);
        setTeamMembers((prev) => [...prev, newMember]);
        return newMember;
      } catch (error) {
        console.error("Error adding team member:", error);
        throw error;
      } finally {
        await refreshTeamMembers();
        setTeamMembersLoading(false);
      }
    },
    [refreshTeamMembers]
  );

  const updateTeamMemberData = useCallback(
    async (id, memberData) => {
      setTeamMembersLoading(true);
      try {
        debugger;
        const updatedMember = await updateTeamMember(id, memberData);
        setTeamMembers((prev) =>
          prev.map((member) => (member.id === id ? updatedMember : member))
        );
        return updatedMember;
      } catch (error) {
        console.error("Error updating team member:", error);
        throw error;
      } finally {
        await refreshTeamMembers();
        setTeamMembersLoading(false);
      }
    },
    [refreshTeamMembers]
  );

  const removeTeamMember = useCallback(
    async (id) => {
      setTeamMembersLoading(true);
      try {
        await deleteTeamMember(id);
        setTeamMembers((prev) => prev.filter((member) => member.id !== id));
      } catch (error) {
        console.error("Error deleting team member:", error);
        throw error;
      } finally {
        await refreshTeamMembers();
        setTeamMembersLoading(false);
      }
    },
    [refreshTeamMembers]
  );

  // Initial data load
  const loadInitialTeamMembers = async () => {
    try {
      setTeamMembersLoading(true);
      const teamData = await fetchTeamMembers();
      setTeamMembers(teamData);
    } catch (error) {
      console.error("Error loading team members:", error);
    } finally {
      setTeamMembersLoading(false);
    }
  };

  return {
    // State
    teamMembers,
    teamMembersLoading,

    // Operations
    refreshTeamMembers,
    addTeamMember,
    updateTeamMember: updateTeamMemberData,
    removeTeamMember,
    loadInitialTeamMembers,
  };
};
